import React, { useState } from 'react';
import '../../CSS/cardStudio.css';
import { TextField, Typography, Slider, Box, Grid, FormControlLabel, RadioGroup, Radio, FormLabel, Switch } from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import ContactDetails from './ContactDetails';
import ImageUploadBox from './ImageUploadBox';

const Page6Settings = () => {
    const { formData, setFormData } = useStudio();

    // Helper to format seconds to MM:SS
    const formatTime = (seconds) => {
        if (!seconds && seconds !== 0) return '';
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    // Helper to parse MM:SS to seconds
    const parseTime = (timeString) => {
        if (!timeString) return '';
        const parts = timeString.split(':');
        if (parts.length === 2) {
            const mins = parseInt(parts[0], 10);
            const secs = parseInt(parts[1], 10);
            if (!isNaN(mins) && !isNaN(secs)) {
                return (mins * 60) + secs;
            }
        }
        return 0;
    };

    const [durationInput, setDurationInput] = useState('');

    React.useEffect(() => {
        setDurationInput(formatTime(formData.musicStartDuration));
    }, [formData.musicStartDuration]);

    const handleDurationChange = (e) => {
        setDurationInput(e.target.value);
    };

    const handleDurationBlur = () => {
        const seconds = parseTime(durationInput);
        setFormData(prev => ({ ...prev, musicStartDuration: seconds }));
        setDurationInput(formatTime(seconds));
    };

    return (
        <Box sx={{ display: 'grid' }}>

            <Typography variant="h6">Nombor Untuk Dihubungi</Typography>

            <ContactDetails />

            <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Lagu</Typography>

            <TextField
                label="Youtube URL"
                fullWidth
                value={formData.musicYoutubeURL}
                onChange={(e) => setFormData(prev => ({ ...prev, musicYoutubeURL: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Durasi Mula"
                fullWidth
                value={durationInput}
                placeholder='00:30'
                onChange={handleDurationChange}
                onBlur={handleDurationBlur}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

            <TextField
                label="Tajuk Lagu"
                fullWidth
                value={formData.musicTitle}
                placeholder='Ed Sheeran - Photographs'
                onChange={(e) => setFormData(prev => ({ ...prev, musicTitle: e.target.value }))}
                margin="normal"
                InputLabelProps={{ shrink: true }}
            />

        </Box>
    );
};

export default Page6Settings;
